// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__16cSr","inner":"Footer_inner__JnqYT","nextIcon":"Footer_nextIcon__tLKsR","innerLeft":"Footer_innerLeft__154Ow"};